export default class ToggleMenu {
    constructor() {
        this.body = document.body;
        this.menu = Array.from(document.querySelectorAll(".jsToggleMenu"));
        this.navbar = document.querySelector(".jsNavbar");
        this.socials = document.querySelector(".jsSocials");
        this.mainMenu = document.querySelector(".main-menu");
        this.menuItems = [
            ...document.querySelectorAll(".main-menu__item--parent"),
        ];
        this.secondaryMenuItems = [
            ...document.querySelectorAll(".secondary-menu__item"),
        ];
        this.secondaryMenus = [...document.querySelectorAll(".secondary-menu")];
        this.backButtons = [
            ...document.querySelectorAll(".secondary-menu__back"),
        ];

        this.closeGalleryButton = document.querySelector(
            ".pswp__button--close"
        );

        this.events();
    }

    events() {
        this.menu.forEach((menu) =>
            menu.addEventListener("click", () => {
                this.toggleMenu();
            })
        );

        this.openSecondaryMenu();
        this.toggleThirdMenu();
        this.backBtn();

        if (this.closeGalleryButton) {
            this.closeGalleryButton.addEventListener(
                "pswpTap",
                function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                },
                true
            );
        }
    }

    reset() {
        if (!this.mainMenu) return;

        // Remove translate of meny
        if (this.mainMenu.classList.contains("opened")) {
            this.mainMenu.classList.remove("opened");
        }

        // Remove visibility of secondaryMenu
        this.secondaryMenus.forEach((item) => {
            item.classList.remove("visible");
        });

        // Remove display of backbuttons
        this.backButtons.forEach((item) => {
            item.classList.remove("active");
        });
    }

    toggleMenu() {
        if (this.menu.length) {
            this.menu.forEach((menu) => {
                menu.classList.toggle("on");

                if (menu.classList.contains("on")) {
                    this.body.style.overflow = "hidden";
                    this.body.style.height = "100%";
                } else {
                    this.body.style.overflow = "auto";
                    this.body.style.height = "auto";
                }
            });
        }

        if (this.navbar) this.navbar.classList.toggle("active");
        if (this.socials) this.socials.classList.toggle("active");

        this.reset();
    }

    openSecondaryMenu() {
        this.menuItems.forEach((item) => {
            const arrow = item.querySelector(".main-menu__arrow");
            const subMenu = item.querySelector(".secondary-menu");
            const backBtn = item.querySelector(".secondary-menu__back");

            arrow.addEventListener("click", () => {
                this.mainMenu.classList.add("opened");
                subMenu.classList.add("visible");
                backBtn.classList.add("active");
            });
        });
    }

    backBtn() {
        this.backButtons.forEach((item) => {
            item.addEventListener("click", () => {
                this.reset();
            });
        });
    }

    toggleThirdMenu() {
        this.secondaryMenuItems.forEach((item) => {
            const arrow = item.querySelector(".secondary-menu__arrow");
            const menu = item.querySelector(".third-menu");

            if (arrow) {
                arrow.addEventListener("click", () => {
                    arrow.classList.toggle("open");
                    menu.classList.toggle("opened");
                });
            }
        });
    }
}
